import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSyncAlt } from "react-icons/fa";
import { GiCardPlay, GiClubs, GiDiamonds } from "react-icons/gi";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";

export default function WaitingGames() {
  const [waitingPlayers, setWaitingPlayers] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    const handleWaitingPlayers = (data) => {
      const filtered = data.filter((p) => p.gameType === "latlat");
      setWaitingPlayers(filtered);
    };

    socket.on("waiting-players", handleWaitingPlayers);

    // 🔥 When game becomes full
    socket.on("game-started", (game) => {
      navigate(`/latlat-play/${game.roomId}`);
    });

    // initial load
    socket.emit("get-waiting-players", { gameType: "latlat" });

    // 🔥 request update every time server sends a room update
    socket.on("room-updated", () => {
      socket.emit("get-waiting-players", { gameType: "latlat" });
    });

    return () => {
      socket.off("waiting-players", handleWaitingPlayers);
      socket.off("game-started");
      socket.off("room-updated");
    };
  }, [navigate]);

  const joinRoom = (player) => {
    socket.emit("join-carta-room", {
      roomId: player.roomId,
      name: userInfo.username,
      phone: userInfo.phone,
    });
  };

  return (
    <div className="w-full max-w-md mx-auto bg-[#134454] rounded-xl shadow-2xl overflow-hidden border border-[#185163]">
      <div className="bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900 px-6 py-5 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <GiClubs className="text-white text-lg animate-pulse" />
          <h2 className="font-semibold text-white text-lg font-serif">
            Waiting Players
          </h2>
          <span className="bg-cyan-600 text-white text-xs px-2 py-1 rounded-full shadow-md animate-pulse">
            {waitingPlayers.length}
          </span>
        </div>

        <FaSyncAlt
          onClick={() =>
            socket.emit("get-waiting-players", { gameType: "latlat" })
          }
          className="text-cyan-400 cursor-pointer hover:rotate-180 hover:scale-110 transition-all duration-500"
        />
      </div>

      {waitingPlayers.length === 0 ? (
        <div className="p-10 text-center">
          <div className="border-2 border-dashed border-[#185163] rounded-2xl p-10 bg-[#0c3745]/80 backdrop-blur-lg animate-fadeIn">
            <GiCardPlay className="mx-auto text-7xl text-cyan-700 mb-5 animate-bounce" />
            <p className="text-gray-300 font-medium text-lg">
              No players waiting
            </p>
          </div>
        </div>
      ) : (
        <div className="p-6 space-y-5">
          {waitingPlayers.map((player) => (
            <div
              key={player.roomId}
              className="bg-[#0c3745]/90 backdrop-blur-lg p-5 rounded-2xl border border-[#185163] flex justify-between items-center transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
            >
              <div>
                <p className="text-white font-semibold text-lg tracking-wide">
                  {player.playerPhone?.slice(0, 4)}***
                </p>
                <p className="text-cyan-400 text-sm mt-1">
                  BetAmount: {player.betAmount} ETB
                </p>
              </div>

              <button
                onClick={() => joinRoom(player)}
                className="bg-green-600 hover:bg-green-700 px-5 py-2 rounded-xl text-white font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Join
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
